module.exports = __webpack_public_path__ + "static/media/foto_HP.2b432121.jpg";